import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import Breadcrumbs from 'vue-2-breadcrumbs';
import * as VueGoogleMaps from 'vue2-google-maps';
import LoaderSplash from '@/components/LoaderSplash.vue';
import Notifications from 'vue-notification'

Vue.use(Notifications);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Breadcrumbs);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBDIUwUG5JDkObAN0KUzej8JNJtXQWvQY4",
    libraries: "places"
  }
});
Vue.component('LoaderSplash',LoaderSplash); //set as global

//import _store from './store';
import routes from './routes';
import "./assets/style.scss";

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import jquery from 'jquery';

jquery.extend(true, jquery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});

Vue.config.productionTip = false;

//const store = new Vuex.Store(_store);
import VuexPersistence from 'vuex-persist';
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
//temp new store TODO remove old store and mocks
const store = new Vuex.Store({
  state:{
    user:{}
  },
  mutations:{
    setUser(state, user) {
      state.user = user;
    },
  },
  getters:{
    user: (state) => {
      return state.user;
    },
  },
  plugins: [vuexLocal.plugin]
});
const router = new VueRouter({ routes, mode: 'history' });

// router.beforeEach((to, from, next) => {
//   let user = store.getters.user;
//
//   if (to.meta.requires_auth && to.meta.role_required.indexOf(user.role) == -1) {
//     next("/");
//   } else {
//     next();
//   }
//
//   console.log(to);
// });

new Vue({
  render: h => h(App),
  router: router,
  store: store
}).$mount('#app');
